export default "__VITE_ASSET__7c5f51ad__"